module.exports = __webpack_public_path__ + "img/Icon_History_Services_Hover.a482725d.svg";